var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam ERP Müşteri Sayısı',"data":_vm.reportCompanyData.totalErpCustomer.toString(),"description":'Tüm Zamanlar',"loading":_vm.reportCompanyDataLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }